import React from "react";

export default function AgeDistributionChart({ distribution, loading }) {
  const groups = distribution?.groups || [];
  const total = distribution?.total || 0;
  const maxCount = Math.max(...groups.map((group) => group.count), 1);
  const geriatricPercentage =
    groups.find((group) => group.id === "over65")?.percentage || 0;

  return (
    <section className="dashboard-age-section">
      <header className="dashboard-age-header">
        <h2 className="dashboard-age-title">
          Distribución por grupos etarios en la consulta
        </h2>
        <p className="dashboard-age-subtitle">
          Composición demográfica de la cartera de pacientes para adaptar
          protocolos diagnósticos. El grupo &gt;65 representa el{" "}
          <strong>{geriatricPercentage}%</strong> y puede requerir cribado
          geriátrico como Yesavage.
        </p>
      </header>

      {loading ? (
        <p className="dashboard-age-empty">Cargando distribución etaria...</p>
      ) : total === 0 ? (
        <p className="dashboard-age-empty">
          No hay pacientes con edad registrada para mostrar la distribución.
        </p>
      ) : (
        <div className="dashboard-age-chart">
          {groups.map((group) => (
            <div key={group.id} className="dashboard-age-row">
              <span className="dashboard-age-label">{group.label}</span>
              <div className="dashboard-age-bar-track">
                <div
                  className={`dashboard-age-bar-fill ${
                    group.id === "over65" ? "dashboard-age-bar-fill--geriatric" : ""
                  }`}
                  style={{ width: `${(group.count / maxCount) * 100}%` }}
                />
              </div>
              <span className="dashboard-age-value">
                {group.count} ({group.percentage}%)
              </span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
